var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldCurvedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 71,
    fill: "none",
    viewBox: "0 0 65 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bold-curved-arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#618DA5",
    d: "M.761 68.944a39 39 0 0 1 .067-2.982q.08-1.47.24-2.928c.21-1.944.495-3.883.883-5.8a65 65 0 0 1 3.28-11.285 62 62 0 0 1 5.34-10.55c2.122-3.343 4.631-6.454 7.421-9.293 2.79-2.835 5.862-5.425 9.205-7.6l1.239-.842 1.288-.758c.86-.499 1.716-1.02 2.59-1.497l2.67-1.338c.45-.213.886-.463 1.345-.65l1.373-.58c7.323-3.129 15.096-5.05 22.923-6.057a3.097 3.097 0 0 1 .794 6.142l-.13.013c-7.407.633-14.726 2.126-21.63 4.734l-1.297.481c-.437.156-.843.366-1.266.549l-2.523 1.127c-.824.406-1.627.856-2.442 1.28l-1.222.646-1.172.726c-3.169 1.872-6.093 4.136-8.79 6.646-2.692 2.514-5.147 5.3-7.265 8.344a58 58 0 0 0-5.446 9.716 62 62 0 0 0-3.588 10.626 60 60 0 0 0-1.088 5.523 49 49 0 0 0-.348 2.79c-.093.922-.16 1.885-.182 2.763v.045a1.14 1.14 0 0 1-1.164 1.11 1.14 1.14 0 0 1-1.11-1.115z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#618DA5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.011,
    d: "m55.388 2.068 7.56 7.355-4.886 9.583"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bold-curved-arrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.756.063h64.197v70H.756z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldCurvedArrow);
export default __webpack_public_path__ + "static/media/bold-curved-arrow.cca16a9f8ad728b63379a266cfa62349.svg";
export { ForwardRef as ReactComponent };